import HubSpotCardLogo from 'src/assets/icons/hubspot.svg';
import FreshalesCardLogo from 'src/assets/icons/freshsales-icon.svg';
import PipedriveCardLogo from 'src/assets/icons/pipedrive-icon.svg';
import SalesforceCardLogo from 'src/assets/icons/salesforce-icon.svg';
import OutreachCardLogo from 'src/assets/icons/outreach-logo.svg';
import ZohoCardLogo from 'src/assets/icons/zoho-crm.svg';
import MicrosoftCardLogo from 'src/assets/icons/ms-dynamics-icon.svg';
import GongCardLogo from 'src/assets/icons/gong-icon.svg';
import SalesloftCardLogo from 'src/assets/icons/salesloft.svg';
import InstantlyCardLogo from 'src/assets/icons/instantly-logo.svg';
import MailchimpCardLogo from 'src/assets/icons/mailchimp-icon.svg';
import HeyReachCardLogo from 'src/assets/icons/heyreach-icon.svg';
import IntercomCardLogo from 'src/assets/icons/intercom-icon.svg';
import LemlistCardLogo from 'src/assets/icons/lemlist-icon.svg';
import SmartleadCardLogo from 'src/assets/icons/smartlead-icon.svg';
import PardotCardLogo from 'src/assets/icons/salesforce-icon.svg';
import GmailCardLogo from 'src/assets/icons/gmail-icon.svg';
import GoogleDriveCardLogo from 'src/assets/icons/google-drive-icon.svg';
import GoogleSlidesCardLogo from 'src/assets/icons/google-slides-icon.svg';
import GoogleDocsCardLogo from 'src/assets/icons/google-docs-icon.svg';
import GoogleAnalyticsCardLogo from 'src/assets/icons/google-analytics-icon.svg';
import SlackCardLogo from 'src/assets/icons/slack-icon.svg';
import AmplitudeCardLogo from 'src/assets/icons/amplitude-icon.svg';
import SegmentCardLogo from 'src/assets/icons/segment-icon.svg';
import MixpanelCardLogo from 'src/assets/icons/mixpanel-icon.svg';
import G2CardLogo from 'src/assets/icons/g2-icon.svg';
import TrustRadiusCardLogo from 'src/assets/icons/trustradius-icon.svg';
import SwarmCardLogo from 'src/assets/icons/swarm-icon.svg';
import TeamsCardLogo from 'src/assets/icons/microsoft-teams-icon.svg';
import OutlookCardLogo from 'src/assets/icons/outlook-icon.svg';
import SendGridCardLogo from 'src/assets/icons/sendgrid-icon.svg';
import PendoCardLogo from 'src/assets/icons/pendo-icon.svg';
import AdobeCardLogo from 'src/assets/icons/adobe-icon.svg';
import SimilarWebCardLogo from 'src/assets/icons/similarweb-icon.svg';
import SemrushCardLogo from 'src/assets/icons/semrush-icon.svg';
import {
  FieldMappingsMockUpType,
  IIntegrationTool,
  IntegrationTableColumn,
  IntegrationsToolsType,
  Option,
  SyncDirection,
  AuthStage,
} from '../types';
import {
  OutreachConnectUrl,
  PipedriveConnectUrl,
  SalesforceConnectUrl,
  getSalesforcePkceConnectUrl,
  ZohoConnectUrl,
  HubSpotConnectUrl,
  GongConnectUrl,
  SalesloftConnectUrl,
  MailchimpConnectUrl,
  GmailConnectUrl,
  GoogleDriveConnectUrl,
  GoogleSlidesConnectUrl,
  GoogleDocsConnectUrl,
  SlackConnectUrl,
  AmplitudeConnectUrl,
  SegmentConnectUrl,
  GoogleAnalyticsConnectUrl,
  TeamsConnectUrl,
  OutlookConnectUrl,
} from 'src/constants/constants';
import { generateSecureState, storeOAuthState } from 'src/utils/utilityMethods';
import { CompanyFieldMappings } from './company';
import { ContactsFieldMappings } from './contacts';
import { LeadFieldMappings } from './lead';
import { OpportunityFieldMappings } from './opportunity';
import {
  CallFieldMappings,
  CallFieldMappingsMicrosoft,
  CallFieldMappingsExpandedActivity,
} from './call';
import { TaskFieldMappings, TaskFieldMappingsExpandedActivity } from './task';
import { MeetingFieldMappings, MeetingFieldMappingsExpandedActivity } from './meeting';
import { SendingFieldMappings } from './sending';
import { EmailFieldMappings } from './email';
import { GlobalSyncFlagResult, PollingFrequencyType } from 'src/store/integrations-v2/types';
import { createTheme } from '@mui/material';
import { colors } from 'src/sass/common/_variables';
import { extractFilterableFields } from '../utils/integrations';

export const IntegrationsTools: IntegrationsToolsType = {
  hubspot: {
    id: 'hubspot',
    providerName: 'HUBSPOT',
    label: 'Hubspot',
    CardLogo: HubSpotCardLogo,
    oauthEnabled: true,
    type: 'CRM',
    integrationStatus: '',
    connectUrl: HubSpotConnectUrl,
    activeStep: 0,
    featureFlag: 'Hubspot Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['enumeration'],
    fieldTypes: {
      Date: ['datetime', 'date'],
      Integer: ['number'],
      Double: ['number'],
      Long: ['number'],
      String: ['string'],
      Set: ['enumeration'], // single/multi select
      Object: ['enumeration'], // single select
      List: ['enumeration'], // multiselect
      Boolean: ['bool'],
    },
    supportedObjects: [
      'Contacts',
      'Accounts',
      'Deals',
      'Leads',
      'Calls',
      'Meetings',
      'Tasks',
      'Emails',
    ],
    supportedActivity: [
      'Contacts',
      'Accounts',
      'Deals',
      'Leads',
      'Calls',
      'Meetings',
      'Tasks',
      'Emails',
    ],
    syncScenarioActivities: ['Calls', 'Meetings', 'Tasks', 'Emails'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    supportsConditionalSync: true,
    supportsActivitySync: true,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: HubSpotConnectUrl,
      },
    },
  },

  freshsales: {
    id: 'freshsales',
    providerName: 'FRESHSALES',
    label: 'Freshsales',
    CardLogo: FreshalesCardLogo,
    oauthEnabled: false,
    type: 'CRM',
    integrationStatus: '',
    connectUrl: '/settings/connect/freshsales/configuration',
    activeStep: 0,
    featureFlag: 'Freshsales Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['multi_select_dropdown', 'dropdown'],
    ApiKeyDescription: 'You can find the API Key in "Settings > API Settings > your API key".',
    DomainDescription1:
      'This is your registered organization domain URL at Freshworks where you have your Freshworks CRM account.',
    DomainDescription2: 'Examples: example.myfreshworks.com, sample.freshworks.com.',
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['number'],
      String: ['text', 'textarea', 'group_field'],
      Set: ['dropdown', 'auto_complete', 'multi_select_dropdown'], // single/multi select
      Object: ['dropdown', 'auto_complete'], // single select
      List: ['multi_select_dropdown'], // multi select
      Boolean: [],
    },
    supportedObjects: ['Contacts', 'Accounts', 'Deals'],
    supportedActivity: ['Contacts', 'Accounts', 'Deals'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    requiredIntegrationFields: {
      company: ['name'],
      contacts: ['emails/mobile_number/twitter'],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description: 'You can find the API Key in "Settings > API Settings > your API key".',
        },
        {
          key: 'domain',
          label: 'Domain URL',
          type: 'url',
          required: true,
          placeholder: 'example.myfreshworks.com',
          description:
            'This is your registered organization domain URL at Freshworks where you have your Freshworks CRM account. Examples: example.myfreshworks.com, sample.freshworks.com.',
          payloadKey: 'bundleAlias',
        },
      ],
    },
  },

  salesforce: {
    id: 'salesforce',
    providerName: 'SALESFORCE',
    label: 'Salesforce',
    CardLogo: SalesforceCardLogo,
    oauthEnabled: true,
    type: 'CRM',
    integrationStatus: '',
    activeStep: 0,
    connectUrl: SalesforceConnectUrl,
    featureFlag: 'Salesforce Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['picklist', 'multipicklist'],
    fieldTypes: {
      Date: ['datetime', 'date'],
      Integer: ['int', 'double', 'currency'],
      Long: ['int', 'double', 'currency'],
      Double: ['int', 'double', 'currency'],
      String: ['textarea', 'string', 'url', 'phone', 'address', 'email', 'currency', 'id'],
      Set: ['picklist', 'multipicklist'], // single/multi select
      Object: ['picklist'], // single select
      List: ['multipicklist'], // multi select
      Boolean: ['boolean'],
    },
    supportedObjects: [
      'Contacts',
      'Accounts',
      'Deals',
      'Leads',
      'Tasks',
      'Meetings',
      'Emails',
      'DealsContacts',
      'Calls',
    ],
    supportedActivity: [
      'Contacts',
      'Accounts',
      'Deals',
      'Leads',
      'Tasks',
      'Meetings',
      'Emails',
      'DealsContacts',
    ],
    syncScenarioActivities: ['Calls', 'Meetings', 'Tasks', 'Emails'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    supportsConditionalSync: true,
    supportsActivitySync: true,
    supportsLeadEntity: true,
    supportsManualSync: true,
    requiredIntegrationFields: {
      company: ['Name'],
      contacts: ['LastName'],
      lead: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: () =>
          getSalesforcePkceConnectUrl(
            'salesforce',
            'salesforce',
            process.env.REACT_APP_DEV_ENV || 'qa',
          ),
      },
    },
  },

  pipedrive: {
    id: 'pipedrive',
    providerName: 'PIPEDRIVE',
    label: 'Pipedrive',
    CardLogo: PipedriveCardLogo,
    oauthEnabled: true,
    type: 'CRM',
    integrationStatus: '',
    connectUrl: PipedriveConnectUrl,
    activeStep: 0,
    featureFlag: 'Pipedrive Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['set', 'enum', 'status', 'varchar_options', 'address', 'user'],
    fieldTypes: {
      Date: ['date'],
      Integer: ['int', 'double', 'org'],
      Long: ['int', 'double', 'org'],
      Double: ['int', 'double', 'org'],
      String: ['varchar', 'monetory', 'string', 'picture', 'stage', 'phone', 'time'],
      Set: ['set', 'enum', 'status', 'varchar_options'], // single/multi select
      Object: ['enum', 'address', 'user', 'status', 'varchar_options'], // single select
      List: ['set', 'varchar_options', 'enum', 'status'], // multi select
      Boolean: ['representation'],
    },
    supportedObjects: ['Contacts', 'Accounts', 'Deals', 'Leads', 'Tasks'],
    supportedActivity: ['Contacts', 'Accounts', 'Deals', 'Leads', 'Tasks'],
    syncScenarioActivities: ['Tasks'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    supportsActivitySync: true,
    requiredIntegrationFields: {
      company: ['name'],
      contacts: ['first_name/last_name'],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: PipedriveConnectUrl,
      },
    },
  },

  zoho: {
    id: 'zoho',
    providerName: 'ZOHO',
    label: 'Zoho',
    CardLogo: ZohoCardLogo,
    oauthEnabled: true,
    type: 'CRM',
    integrationStatus: '',
    connectUrl: ZohoConnectUrl,
    activeStep: 0,
    featureFlag: 'Zoho Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['enumeration'],
    fieldTypes: {
      Date: ['date', 'datetime'],
      Integer: ['int', 'number', 'bigint', 'currency'],
      Long: ['int', 'number', 'bigint', 'currency'],
      Double: ['double', 'decimal', 'currency'],
      String: [
        'text',
        'varchar',
        'email',
        'phone',
        'url',
        'textarea',
        'website',
        'ownerlookup',
        'picklist',
      ],
      Set: ['multiselectlookup', 'subform'], // Multi-select fields
      Object: [
        'lookup', // Relational fields
        'owner', // Record owner field
      ],
      List: ['multiselectlookup', 'subform'], // Multi-select or subform fields
      Boolean: ['boolean'], // Checkbox or true/false fields
    },
    supportedObjects: ['Contacts', 'Accounts', 'Deals', 'Leads'],
    supportedActivity: ['Contacts', 'Accounts', 'Deals', 'Leads'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    supportsLeadEntity: true,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: ZohoConnectUrl,
      },
    },
  },

  microsoft: {
    id: 'microsoft',
    providerName: 'MICROSOFT',
    label: 'Microsoft Dynamics',
    CardLogo: MicrosoftCardLogo,
    oauthEnabled: true,
    type: 'CRM',
    integrationStatus: '',
    connectUrl: '',
    activeStep: 0,
    featureFlag: 'Microsoft Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['PicklistType', 'MultiSelectPicklistType', 'StatusType', 'StateType'],
    fieldTypes: {
      Date: ['DateTimeType'],
      Integer: ['IntegerType', 'BigIntType'],
      Long: ['BigIntType'],
      Double: ['DoubleType', 'DecimalType', 'MoneyType'],
      String: [
        'StringType',
        'MemoType',
        'UniqueidentifierType',
        'EntityNameType',
        'ImageType',
        'VirtualType',
      ],
      Set: ['MultiSelectPicklistType'],
      Object: [
        'LookupType',
        'OwnerType',
        'CustomerType',
        'PicklistType',
        'StatusType',
        'StateType',
      ],
      List: ['MultiSelectPicklistType'],
      Boolean: ['BooleanType'],
    },
    supportedObjects: [
      'Contacts',
      'Accounts',
      'Leads',
      'Deals',
      'Tasks',
      'Calls',
      'Emails',
      'Meetings',
    ],
    supportedActivity: [
      'Contacts',
      'Accounts',
      'Leads',
      'Deals',
      'Tasks',
      'Calls',
      'Emails',
      'Meetings',
    ],
    syncScenarioActivities: ['Calls', 'Meetings', 'Tasks', 'Emails'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    supportsConditionalSync: true,
    supportsActivitySync: true,
    supportsLeadEntity: true,
    supportsManualSync: true,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [
        {
          key: 'subdomain',
          label: 'Subdomain',
          type: 'text',
          required: true,
          description:
            'Enter your organization\'s subdomain. For example, if your Dynamics 365 URL is "https://contoso.crm.dynamics.com", enter "contoso".',
          placeholder: 'contoso',
          stage: AuthStage.PRE_AUTH,
          payloadKey: 'crmTenantId',
          validationRegex: '^[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]$', // Subdomain validation
        },
      ],
      // Note: oauth.url is NOT stored here to avoid Redux serialization errors
      // Instead, MicrosoftConnectUrl is imported directly in components when needed
    },
  },

  salesloft: {
    id: 'salesloft',
    providerName: 'SALESLOFT',
    label: 'Salesloft',
    CardLogo: SalesloftCardLogo,
    oauthEnabled: true,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: SalesloftConnectUrl,
    activeStep: 0,
    featureFlag: 'Salesloft Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [], // single/multi select
      Object: [], // single select
      List: [], // multiselect
      Boolean: [],
    },
    supportedObjects: ['Contacts', 'Accounts', 'Calls', 'Tasks', 'Meetings', 'Sendings'],
    supportedActivity: [
      'Contacts',
      'Accounts',
      'Calls',
      'Tasks',
      'Meetings',
      'Sendings',
      'Sequences',
      'SequenceSteps',
    ],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: SalesloftConnectUrl,
      },
    },
  },

  // cmp integrations
  outreach: {
    id: 'outreach',
    providerName: 'OUTREACH',
    label: 'Outreach',
    CardLogo: OutreachCardLogo,
    oauthEnabled: true,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: OutreachConnectUrl,
    activeStep: 0,
    featureFlag: 'Outreach Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [], // single/multi select
      Object: [], // single select
      List: [], // multiselect
      Boolean: [],
    },
    supportedObjects: ['Contacts', 'Accounts', 'Calls', 'Tasks', 'Sendings'],
    supportedActivity: [
      'Contacts',
      'Accounts',
      'Calls',
      'Tasks',
      'Sendings',
      'Sequences',
      'SequenceSteps',
    ],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: OutreachConnectUrl,
      },
    },
  },

  gong: {
    id: 'gong',
    providerName: 'GONG',
    label: 'Gong',
    CardLogo: GongCardLogo,
    oauthEnabled: true,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: GongConnectUrl,
    activeStep: 0,
    featureFlag: 'Gong Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: ['optionset', 'multiselectoptionset'],
    fieldTypes: {
      Date: ['date', 'datetime'],
      Integer: ['integer', 'money'],
      Long: ['bigint', 'money'],
      Double: ['decimal', 'money'],
      String: [
        'string',
        'text',
        'email',
        'phone',
        'url',
        'memo',
        'uniqueidentifier',
        'lookup',
        'owner',
      ],
      Set: ['multiselectlookup', 'subform'], // Multi-select fields
      Object: [
        'lookup', // Relational fields
        'owner', // Record owner field
        'optionset', // single select
      ],
      List: ['multiselectoptionset'], // Multi-select or subform fields
      Boolean: ['boolean'], // Checkbox or true/false fields
    },
    supportedObjects: ['Calls'],
    supportedActivity: ['Calls'],
    supportedStage: ['USER_MAPPING_STAGE', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.INBOUND_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: GongConnectUrl,
      },
    },
  },

  instantly: {
    id: 'instantly',
    providerName: 'INSTANTLY',
    label: 'Instantly',
    CardLogo: InstantlyCardLogo,
    oauthEnabled: false,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: '/settings/connect/instantly/configuration',
    activeStep: 0,
    featureFlag: 'Instantly Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription:
      'You can find the API Key in your Instantly account settings under "API & Webhooks".',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [], // single/multi select
      Object: [], // single select
      List: [], // multiselect
      Boolean: [],
    },
    supportedObjects: ['Leads'],
    supportedActivity: ['Leads'],
    // Outbound-only integration: No test stage needed (no inbound data to test)
    supportedStage: ['USER_MAPPING_STAGE', 'ENTITY_MAPPING_STAGE'],
    syncDirection: SyncDirection.OUTBOUND_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'You can find the API Key in your Instantly account settings under "API & Webhooks".',
        },
      ],
    },
  },

  mailchimp: {
    id: 'mailchimp',
    providerName: 'MAILCHIMP',
    label: 'Mailchimp',
    CardLogo: MailchimpCardLogo,
    oauthEnabled: true,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: MailchimpConnectUrl,
    activeStep: 0,
    featureFlag: 'Mailchimp Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['birthday'],
      Integer: ['integer', 'number'],
      Double: ['number'],
      Long: ['integer', 'number'],
      String: ['string', 'text', 'phone', 'address'],
      Set: [],
      Object: ['object', 'address'],
      List: [],
      Boolean: ['boolean'],
    },
    supportedObjects: ['Contacts', 'List'],
    supportedActivity: ['List'],
    supportedStage: ['SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: MailchimpConnectUrl,
      },
    },
  },

  heyreach: {
    id: 'heyreach',
    providerName: 'HEYREACH',
    label: 'HeyReach',
    CardLogo: HeyReachCardLogo,
    oauthEnabled: false,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: '/settings/connect/heyreach/configuration',
    activeStep: 0,
    featureFlag: 'Heyreach Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription: 'You can find the API Key in your HeyReach account settings.',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Leads'],
    supportedActivity: ['Leads'],
    // Outbound-only integration: No test stage needed (no inbound data to test)
    supportedStage: ['ENTITY_MAPPING_STAGE'],
    syncDirection: SyncDirection.OUTBOUND_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description: 'You can find the API Key in your HeyReach account settings.',
        },
      ],
    },
  },

  intercom: {
    id: 'intercom',
    providerName: 'INTERCOM',
    label: 'Intercom',
    CardLogo: IntercomCardLogo,
    oauthEnabled: false,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: '/settings/connect/intercom/configuration',
    activeStep: 0,
    featureFlag: 'Intercom Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription:
      'You can find the API Key in your Intercom account settings under Developer Hub > Your Apps > Authentication.',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Contacts', 'Leads'],
    supportedActivity: ['Contacts', 'Accounts', 'Leads', 'Tickets', 'Conversations'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.INBOUND_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: ['email'],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'You can find the API Key in your Intercom account settings under Developer Hub > Your Apps > Authentication.',
        },
      ],
    },
  },

  lemlist: {
    id: 'lemlist',
    providerName: 'LEMLIST',
    label: 'Lemlist',
    CardLogo: LemlistCardLogo,
    oauthEnabled: false,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: '/settings/connect/lemlist/configuration',
    activeStep: 0,
    featureFlag: 'Lemlist Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription:
      'You can find the API Key in your Lemlist account settings under Settings > Integrations > API.',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Sequences'],
    supportedActivity: ['Sequences'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'TEST_STAGE'],
    syncDirection: SyncDirection.INBOUND_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: ['email'],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'You can find the API Key in your Lemlist account settings under Settings > Integrations > API.',
        },
      ],
    },
  },

  smartlead: {
    id: 'smartlead',
    providerName: 'SMARTLEAD',
    label: 'Smartlead',
    CardLogo: SmartleadCardLogo,
    oauthEnabled: false,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: '/settings/connect/smartlead/configuration',
    activeStep: 0,
    featureFlag: 'Smartlead Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription: 'You can find the API Key in your Smartlead account settings.',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Leads'],
    supportedActivity: ['Sequences', 'Leads', 'CampaignContacts'],
    supportedStage: ['ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    requiredIntegrationFields: {
      company: [],
      contacts: ['email'],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description: 'You can find the API Key in your Smartlead account settings.',
        },
      ],
    },
  },

  pardot: {
    id: 'pardot',
    providerName: 'PARDOT',
    label: 'Pardot',
    CardLogo: PardotCardLogo,
    oauthEnabled: true,
    type: 'CMP',
    integrationStatus: '',
    connectUrl: '',
    activeStep: 0,
    featureFlag: 'Pardot Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Contacts'],
    supportedActivity: ['Contacts', 'Sequences'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    supportsLeadEntity: true,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [
        {
          key: 'businessUnitId',
          label: 'Business Unit ID',
          type: 'text',
          required: true,
          description: 'Your Pardot Business Unit ID',
          stage: AuthStage.PRE_AUTH,
          payloadKey: 'crmTenantId',
          validationRegex: '^[a-zA-Z0-9]+$', // Alphanumeric validation for Business Unit ID
        },
      ],
      // Note: oauth.url is NOT stored here to avoid Redux serialization errors
      // Instead, PardotConnectUrl is imported directly in components when needed
    },
  },

  // AUTH_ONLY Integrations - Simple OAuth with no configuration stages
  // These integrations only authenticate and don't sync data or require field mapping
  gmail: {
    id: 'gmail',
    providerName: 'GMAIL',
    label: 'Gmail',
    CardLogo: GmailCardLogo,
    oauthEnabled: true, // OAuth required first
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: GmailConnectUrl, // OAuth redirect URL
    activeStep: 0,
    featureFlag: 'Gmail Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Messages'],
    supportedActivity: ['Messages'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH', // OAuth first, then file upload
      fields: [
        //   {
        //     key: 'credentialData',
        //     label: 'Google Service Account Credentials',
        //     type: 'file',
        //     required: true, // Required after OAuth
        //     description: 'Upload your Google Service Account JSON credentials file. This file contains the private key and service account information needed to authenticate with Gmail API.',
        //     payloadKey: 'credentialData',
        //     stage: AuthStage.POST_AUTH, // Show AFTER OAuth callback
        //   },
      ],
      oauth: {
        url: GmailConnectUrl, // OAuth callback flow
      },
    },
  },

  googledrive: {
    id: 'googledrive',
    providerName: 'GOOGLE_DRIVE',
    label: 'Google Drive',
    CardLogo: GoogleDriveCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: GoogleDriveConnectUrl,
    activeStep: 0,
    featureFlag: 'Google Drive Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Files'],
    supportedActivity: ['Files'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [
        //   {
        //     key: 'credentialData',
        //     label: 'Google Service Account Credentials',
        //     type: 'file',
        //     required: true,
        //     description: 'Upload your Google Service Account JSON credentials file. This file contains the private key and service account information needed to authenticate with Google Drive API.',
        //     payloadKey: 'credentialData',
        //     stage: AuthStage.POST_AUTH,
        //   },
      ],
      oauth: {
        url: GoogleDriveConnectUrl,
      },
    },
  },

  googleslides: {
    id: 'googleslides',
    providerName: 'GOOGLE_SLIDES',
    label: 'Google Slides',
    CardLogo: GoogleSlidesCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: GoogleSlidesConnectUrl,
    activeStep: 0,
    featureFlag: 'Google Slides Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Files'],
    supportedActivity: ['Files'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [
        //   {
        //     key: 'credentialData',
        //     label: 'Google Service Account Credentials',
        //     type: 'file',
        //     required: true,
        //     description: 'Upload your Google Service Account JSON credentials file. This file contains the private key and service account information needed to authenticate with Google Slides API.',
        //     payloadKey: 'credentialData',
        //     stage: AuthStage.POST_AUTH,
        //   },
      ],
      oauth: {
        url: GoogleSlidesConnectUrl,
      },
    },
  },

  googledocs: {
    id: 'googledocs',
    providerName: 'GOOGLE_DOCS',
    label: 'Google Docs',
    CardLogo: GoogleDocsCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: GoogleDocsConnectUrl,
    activeStep: 0,
    featureFlag: 'Google Docs Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Files'],
    supportedActivity: ['Files'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [
        //   {
        //     key: 'credentialData',
        //     label: 'Google Service Account Credentials',
        //     type: 'file',
        //     required: true,
        //     description: 'Upload your Google Service Account JSON credentials file. This file contains the private key and service account information needed to authenticate with Google Docs API.',
        //     payloadKey: 'credentialData',
        //     stage: AuthStage.POST_AUTH,
        //   },
      ],
      oauth: {
        url: GoogleDocsConnectUrl,
      },
    },
  },

  slack: {
    id: 'slack',
    providerName: 'SLACK',
    label: 'Slack',
    CardLogo: SlackCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: SlackConnectUrl,
    activeStep: 0,
    featureFlag: 'Slack Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['List'],
    supportedActivity: ['List'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: SlackConnectUrl,
      },
    },
  },

  amplitude: {
    id: 'amplitude',
    providerName: 'AMPLITUDE',
    label: 'Amplitude',
    CardLogo: AmplitudeCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/amplitude/configuration',
    activeStep: 0,
    featureFlag: 'Amplitude Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Export'],
    supportedActivity: ['Export'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'Your Amplitude API Key. You can find this in Settings > Projects > [Your Project] > General.',
        },
        {
          key: 'secretKey',
          label: 'Secret Key',
          type: 'password',
          required: true,
          description:
            'Your Amplitude Secret Key. You can find this in Settings > Projects > [Your Project] > General.',
        },
      ],
    },
  },

  segment: {
    id: 'segment',
    providerName: 'SEGMENT',
    label: 'Segment',
    CardLogo: SegmentCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/segment/configuration',
    activeStep: 0,
    featureFlag: 'Segment Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: [],
    supportedActivity: [],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'accessToken',
          label: 'Access Token',
          type: 'password',
          required: true,
          description:
            'Your Segment Access Token. You can create one in Settings > Workspace Settings > Access Management > Tokens.',
        },
      ],
    },
  },

  mixpanel: {
    id: 'mixpanel',
    providerName: 'MIXPANEL',
    label: 'Mixpanel',
    CardLogo: MixpanelCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/mixpanel/configuration',
    activeStep: 0,
    featureFlag: 'Mixpanel Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Event', 'Contacts', 'EventHistory'],
    supportedActivity: ['Event', 'Contacts', 'EventHistory'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'HYBRID',
      fields: [
        {
          key: 'username',
          label: 'Account Username',
          type: 'text',
          required: true,
          description: 'Your Mixpanel Account Username',
        },
        {
          key: 'secret',
          label: 'Account Secret',
          type: 'password',
          required: true,
          description: 'Your Mixpanel Account Secret.',
        },
        {
          key: 'organization_id',
          label: 'Organization',
          type: 'dropdown',
          required: true,
          description: 'Select your Mixpanel organization',
          options: [], // Populated after validation
        },
      ],
    },
  },
  g2crowd: {
    id: 'g2crowd',
    providerName: 'G2CROWD',
    label: 'G2Crowd',
    CardLogo: G2CardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/g2crowd/configuration',
    activeStep: 0,
    featureFlag: 'G2Crowd Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Products'],
    supportedActivity: ['Products'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'Your G2 API Key. You can find this in your G2 account settings under API Access.',
        },
      ],
    },
  },
  trustradius: {
    id: 'trustradius',
    providerName: 'TRUSTRADIUS',
    label: 'TrustRadius',
    CardLogo: TrustRadiusCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/trustradius/configuration',
    activeStep: 0,
    featureFlag: 'Trustradius Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Intent', 'Quotes'],
    supportedActivity: ['Intent', 'Quotes'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'Your Trustradius API Key. You can find this in your Trustradius account settings under API Access.',
        },
      ],
    },
  },
  googleanalytics: {
    id: 'googleanalytics',
    providerName: 'GOOGLE_ANALYTICS',
    label: 'Google Analytics',
    CardLogo: GoogleAnalyticsCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: GoogleAnalyticsConnectUrl,
    activeStep: 0,
    featureFlag: 'Google Analytics Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: ['Report'],
    supportedActivity: ['Report'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [
        {
          key: 'property_id',
          label: 'Property',
          type: 'dropdown',
          required: true,
          description: 'Select your Google Analytics 4 property',
          options: [], // Populated after OAuth
          stage: AuthStage.POST_AUTH,
        },
      ],
      oauth: {
        url: GoogleAnalyticsConnectUrl,
      },
    },
  },
  swarm: {
    id: 'swarm',
    providerName: 'SWARM',
    label: 'Swarm',
    CardLogo: SwarmCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/swarm/configuration',
    activeStep: 0,
    featureFlag: 'Swarm Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: [],
    supportedActivity: [],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description: 'Your Swarm API Key. You can find this in your Swarm account settings.',
        },
      ],
    },
  },

  teams: {
    id: 'teams',
    providerName: 'TEAMS',
    label: 'Microsoft Teams',
    CardLogo: TeamsCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: TeamsConnectUrl,
    activeStep: 0,
    featureFlag: 'Teams Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Users'],
    supportedActivity: ['Users'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: TeamsConnectUrl,
      },
    },
  },

  outlook: {
    id: 'outlook',
    providerName: 'OUTLOOK',
    label: 'Outlook',
    CardLogo: OutlookCardLogo,
    oauthEnabled: true,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: OutlookConnectUrl,
    activeStep: 0,
    featureFlag: 'Outlook Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Users'],
    supportedActivity: ['Users'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'OAUTH',
      fields: [],
      oauth: {
        url: OutlookConnectUrl,
      },
    },
  },

  sendgrid: {
    id: 'sendgrid',
    providerName: 'SENDGRID',
    label: 'SendGrid',
    CardLogo: SendGridCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/sendgrid/configuration',
    activeStep: 0,
    featureFlag: 'SendGrid Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: [],
    supportedActivity: [],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description: 'Enter your SendGrid API Key',
          placeholder: 'SG.xxxxxxxxxxxxxxxx',
        },
      ],
    },
  },

  pendo: {
    id: 'pendo',
    providerName: 'PENDO',
    label: 'Pendo',
    CardLogo: PendoCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/pendo/configuration',
    activeStep: 0,
    featureFlag: 'Pendo Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date'],
      Integer: ['number'],
      Long: ['number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea', 'picklist'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference', 'object_reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Events'],
    supportedActivity: ['Events'],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'Integration Key',
          type: 'password',
          required: true,
          description: 'Enter your Pendo Integration Key',
          placeholder: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
        },
      ],
    },
  },
  adobemarketo: {
    id: 'adobemarketo',
    providerName: 'ADOBE_MARKETO',
    label: 'Adobe Marketo',
    CardLogo: AdobeCardLogo,
    oauthEnabled: false,
    type: 'CRM',
    integrationStatus: '',
    connectUrl: '/settings/connect/adobemarketo/configuration',
    activeStep: 0,
    featureFlag: 'Adobe Marketo Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    fieldTypes: {
      Date: ['date', 'datetime'],
      Integer: ['integer', 'number'],
      Long: ['integer', 'number'],
      Double: ['decimal', 'float', 'number'],
      String: ['text', 'string', 'email', 'url', 'phone', 'textarea'],
      Set: ['multiselect'],
      Object: ['lookup', 'reference'],
      List: ['multiselect'],
      Boolean: ['boolean', 'checkbox'],
    },
    supportedObjects: ['Contacts', 'List'],
    supportedActivity: ['List'],
    supportedStage: ['USER_MAPPING_STAGE', 'SYNC_RULE_SETUP', 'ENTITY_MAPPING_STAGE', 'TEST_STAGE'],
    syncDirection: SyncDirection.BIDIRECTIONAL,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'clientUrl',
          label: 'Client URL',
          type: 'url',
          required: true,
          description: 'Your Adobe Marketo REST API endpoint URL',
          placeholder: 'https://dummyurl.com',
        },
        {
          key: 'clientId',
          label: 'Client ID',
          type: 'text',
          required: true,
          description: 'Your Adobe Marketo Client ID',
        },
        {
          key: 'clientSecret',
          label: 'Client Secret',
          type: 'password',
          required: true,
          description: 'Your Adobe Marketo Client Secret',
        },
      ],
    },
  },

  semrush: {
    id: 'semrush',
    providerName: 'SEMRUSH',
    label: 'Semrush',
    CardLogo: SemrushCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/semrush/configuration',
    activeStep: 0,
    featureFlag: 'Semrush Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription:
      'You can find the API Key in your Semrush account settings under API section.',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: [],
    supportedActivity: [],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'Your Semrush API Key. You can find this in your Semrush account settings under API section.',
        },
      ],
    },
  },

  similarweb: {
    id: 'similarweb',
    providerName: 'SIMILARWEB',
    label: 'SimilarWeb',
    CardLogo: SimilarWebCardLogo,
    oauthEnabled: false,
    type: 'AUTH',
    integrationStatus: '',
    connectUrl: '/settings/connect/similarweb/configuration',
    activeStep: 0,
    featureFlag: 'SimilarWeb Integration',
    syncDataLoading: false,
    syncData: [],
    lastSyncedAt: '',
    dropdownFieldTypes: [],
    ApiKeyDescription:
      'You can find the API Key in your SimilarWeb account settings under API Access.',
    fieldTypes: {
      Date: [],
      Integer: [],
      Double: [],
      Long: [],
      String: [],
      Set: [],
      Object: [],
      List: [],
      Boolean: [],
    },
    supportedObjects: [],
    supportedActivity: [],
    supportedStage: [],
    syncDirection: SyncDirection.AUTH_ONLY,
    requiredIntegrationFields: {
      company: [],
      contacts: [],
    },
    authConfig: {
      mode: 'API_KEY',
      fields: [
        {
          key: 'apiKey',
          label: 'API Key',
          type: 'password',
          required: true,
          description:
            'Your SimilarWeb API Key. You can find this in your SimilarWeb account settings under API Access.',
        },
      ],
    },
  },
};

export const IntegrationStatus = {
  /**
   * When user is on User mapping screen step during integration
   */
  STARTED: 'STARTED',
  USER_MAPPING_STAGE: 'USER_MAPPING_STAGE',

  SYNC_RULE_SETUP: 'SYNC_RULE_SETUP',

  /**
   * When user is on Field mapping screen step during integration
   */
  ENTITY_MAPPING_STAGE: 'ENTITY_MAPPING_STAGE',

  /**
   * When user is on Test and Run screen step during integration
   */
  TEST_STAGE: 'TEST_STAGE',

  /**
   * When user is on Manage screen
   */
  CONFIGURED: 'CONFIGURED',
  COMPLETED: 'COMPLETED',

  /**
   * When user reset the mappings from card during integration
   */
  RESET: 'RESET',

  /**
   * When the sync jobs are configured and user disconnect the integration
   */
  DISCONNECTED: 'DISCONNECTED',
};

/**
 * When the integration configuration is in progress
 */
export const ResumeStatus = [
  IntegrationStatus.STARTED,
  IntegrationStatus.STARTED.toLowerCase(),
  IntegrationStatus.USER_MAPPING_STAGE,
  IntegrationStatus.SYNC_RULE_SETUP,
  IntegrationStatus.ENTITY_MAPPING_STAGE,
  IntegrationStatus.TEST_STAGE,
];

export const DisconnectedStatus = [
  IntegrationStatus.DISCONNECTED,
  IntegrationStatus.RESET,
  undefined,
  null,
  '',
];

export const IntegrationStatusToStepForCrm = {
  [IntegrationStatus.SYNC_RULE_SETUP]: 1,
  [IntegrationStatus.ENTITY_MAPPING_STAGE]: 2,
  [IntegrationStatus.TEST_STAGE]: 3,
};
export const IntegrationStatusToStepForCmp = {
  [IntegrationStatus.ENTITY_MAPPING_STAGE]: 1,
  [IntegrationStatus.TEST_STAGE]: 2,
};

/**
 * Get supported stages for an integration based on its sync direction
 * Automatically excludes SYNC_RULE_SETUP stage for INBOUND_ONLY or OUTBOUND_ONLY integrations
 * Returns empty array for AUTH_ONLY integrations (no configuration stages)
 * @param integration - The integration tool configuration
 * @returns Filtered array of supported stages
 */
export const getSupportedStages = (integration: IIntegrationTool): string[] => {
  const { supportedStage = [], syncDirection } = integration;

  // For AUTH_ONLY integrations, no configuration stages needed
  if (syncDirection === SyncDirection.AUTH_ONLY) {
    return [];
  }

  // For unidirectional sync (inbound or outbound only), exclude SYNC_RULE_SETUP stage
  if (
    syncDirection === SyncDirection.INBOUND_ONLY ||
    syncDirection === SyncDirection.OUTBOUND_ONLY
  ) {
    return supportedStage.filter((stage) => stage !== IntegrationStatus.SYNC_RULE_SETUP);
  }

  // For bidirectional or unspecified, return all stages
  return supportedStage;
};

/**
 * Check if an integration is AUTH_ONLY type (no configuration stages)
 * @param integration - The integration tool configuration
 * @returns true if integration is AUTH_ONLY
 */
export const isAuthOnlyIntegration = (integration: IIntegrationTool | undefined): boolean => {
  return integration?.syncDirection === SyncDirection.AUTH_ONLY;
};

/**
 * Dynamically generates status-to-step mapping based on supportedStage config
 * @param supportedStage - Array of integration stages
 * @returns Mapping of status to step index
 */
export const getIntegrationStatusToStepMapping = (
  supportedStage: string[] = [],
): Record<string, number> => {
  const mapping: Record<string, number> = {};

  supportedStage.forEach((status, index) => {
    mapping[status] = index;
  });

  return mapping;
};

export const IntegrationStatusTracking = {
  'Field mapping': IntegrationStatus.ENTITY_MAPPING_STAGE,
  'User mapping': IntegrationStatus.USER_MAPPING_STAGE,
  'Sync scenario': IntegrationStatus.SYNC_RULE_SETUP,
};

export const IntegrationsListRoute = '/settings/integrations';

export const ColumnType = {
  Text: 'Text',
  DropDown: 'DropDown',
  AutoComplete: 'AutoComplete',
  Checkbox: 'Checkbox',
  CheckboxWithDorpdown: 'CheckboxWithDorpdown',
  ValueMapIcon: 'ValueMapIcon',
  Status: 'Status',
  Icon: 'Icon',
};

export const IntegrationEntityNames = {
  Owners: 'Owners',
  Contact: 'Contact',
  Companies: 'Companies',
  Lead: 'Lead',
  Deals: 'Deals',
  DealStages: 'DealStages',
  ProspectStages: 'ProspectStages',
  Call: 'Calls',
  Task: 'Tasks',
  Meeting: 'Events',
  Sending: 'Mailings',
  Email: 'Emails',
  Sequences: 'Sequences',
  SequenceSteps: 'SequenceSteps',
  Ticket: 'Tickets',
  Conversation: 'Conversations',
  DealsContacts: 'DealsContacts',
  Products: 'Products',
  Intent: 'Intent',
  Quotes: 'Quotes',
  Report: 'Report',
  Export: 'Export',
  Users: 'Users',
  Files: 'Files',
};

export const selectedData = {
  value: '',
  to_crm_if_blank: true,
  from_sprouts: false,
  nosync: false,
  // crm to sproutes
  toSprouts: true,
  dontSyncToSprouts: false,
};

// Function to get field mappings based on provider
export const getFieldMappingsMocData = (providerName?: string): FieldMappingsMockUpType[] => {
  // Use the expanded activity field mappings for providers that support activity sync.
  const usesNewActivityMappings = ['SALESFORCE', 'PIPEDRIVE', 'HUBSPOT', 'MICROSOFT'].includes(
    providerName || '',
  );
  // Microsoft Dynamics supports inbound sync for calls — use its own call mapping
  const isMicrosoft = providerName === 'MICROSOFT';

  const getCallMapping = () => {
    if (isMicrosoft) return CallFieldMappingsMicrosoft;
    if (usesNewActivityMappings) return CallFieldMappingsExpandedActivity;
    return CallFieldMappings;
  };

  return structuredClone([
    CompanyFieldMappings,
    ContactsFieldMappings,
    LeadFieldMappings,
    OpportunityFieldMappings,
    getCallMapping(),
    usesNewActivityMappings ? TaskFieldMappingsExpandedActivity : TaskFieldMappings,
    usesNewActivityMappings ? MeetingFieldMappingsExpandedActivity : MeetingFieldMappings,
    SendingFieldMappings,
    EmailFieldMappings,
  ]);
};

// Backward compatibility: export the default array
export const FieldMappingsMocData: FieldMappingsMockUpType[] = getFieldMappingsMocData();

export const MapValuesFiledTypes = [
  'picklist(s)',
  'enumeration(h)',
  'dropdown(f)',
  'multi_select_dropdown(f)',
];

export const SyncStatusColumns: IntegrationTableColumn[] = [
  { label: 'Last sync at', id: 'lastSyncAt', type: ColumnType.Text },
  { label: 'Records fetched', id: 'recordsFetched', type: ColumnType.Text },
  { label: 'Records created', id: 'recordsCreated', type: ColumnType.Text },
  { label: 'Records updated', id: 'recordsUpdated', type: ColumnType.Text },
  { label: 'Source', id: 'source', type: ColumnType.Text },
  { label: 'Status', id: 'syncStatus', type: ColumnType.Text },
  // { label: 'Sync direction', id: 'syncDirection', type: ColumnType.Text },
  { label: 'Error details', id: 'errorDetails', type: ColumnType.Text },
];

export const SyncNowThreshold = 5;

export const migrateHistoricDataOptions: Option[] = [
  { label: '1 Week', value: '1 Week' },
  { label: '2 Weeks', value: '2 Weeks' },
  { label: '1 Month', value: '1 Month' },
  { label: '3 Months', value: '3 Months' },
  { label: '6 Months', value: '6 Months' },
];

export const defaultHistoricSyncInterval = '1 Month';

export const PollingFrequencyOptions: PollingFrequencyType[] = [
  { label: '5 minutes', value: 'EVERY_FIVE_MINUTES' },
  { label: '15 minutes', value: 'EVERY_FIFTEEN_MINUTES' },
  { label: '30 minutes', value: 'EVERY_THIRTY_MINUTES' },
  { label: '1 hour', value: 'HOURLY' },
  { label: '3 hours', value: 'EVERY_3_HOURS' },
  { label: '6 hours', value: 'EVERY_6_HOURS' },
  { label: '12 hours', value: 'EVERY_12_HOURS' },
  { label: '1 Day', value: 'DAILY' },
];

export const defaultSyncNewSproutsContactsTo = 'Contact';

// Mapping between supported object names and their internal field IDs
export const supportedObjectsToFieldIds: Record<string, string> = {
  Contacts: 'contacts',
  Accounts: 'company',
  Deals: 'opportunity',
  Leads: 'lead',
  Calls: 'call',
  Tasks: 'task',
  Meetings: 'meeting',
  Sendings: 'sending',
  Emails: 'email',
  Sequences: 'sequence',
  SequenceSteps: 'sequence_steps',
  Tickets: 'ticket',
  DealsContacts: 'deals_contacts',
  Conversations: 'conversation',
  Messages: 'messages',
  CampaignContacts: 'campaign_contacts',
  // slack
  List: 'list',
  // Mixpanel entities
  Event: 'event',
  EventHistory: 'event_history',
  // Pendo entities
  Events: 'events',
  // MS Teams and Outlook entities
  Users: 'users',
  //G2Crowd entities
  Products: 'products',
  // Trustradius entities
  Intent: 'intent',
  Quotes: 'quotes',
  // Google Analytics entities
  Report: 'report',
  // Amplitude entities
  Export: 'export',
  // Drive entities
  Files: 'files',
};

// Mapping between field IDs and provider entity IDs
// Used in multiple places to convert field IDs to provider entity IDs
export const getEntityIdMap = (providerName: string): Record<string, string> => {
  const p = providerName;
  return {
    contacts: `${p}_CONTACTS`,
    company: `${p}_ACCOUNT`,
    opportunity: `${p}_DEALS`,
    lead: `${p}_LEAD`,
    call: `${p}_CALL`,
    task: `${p}_TASK`,
    meeting: `${p}_MEETING`,
    sending: `${p}_SENDING`,
    email: `${p}_EMAIL`,
    sequence: `${p}_SEQUENCE`,
    sequence_steps: `${p}_SEQUENCE_STEPS`,
    deals_contacts: `${p}_DEALS_CONTACTS`,
    ticket: `${p}_TICKETS`,
    conversation: `${p}_CONVERSATION`,
    messages: `${p}_MESSAGE`,
    campaign_contacts: `${providerName}_CAMPAIGN_CONTACTS`,
    // slack
    list: `${p}_LIST`,
    // Mixpanel entities
    event: `${p}_EVENT`,
    event_history: `${p}_EVENT_HISTORY`,
    // Pendo entities
    events: `${p}_EVENTS`,
    // MS Teams and Outlook entities
    users: `${p}_USERS`,
    //G2Crowd entities
    products: `${p}_PRODUCTS`,
    // Trustradius entities
    intent: `${p}_INTENT`,
    quotes: `${p}_QUOTES`,
    // Google Analytics entities
    report: `${p}_REPORT`,
    // Amplitude entities
    export: `${p}_EXPORT`,
    // Google Drive, Docs, Slides entities
    files: `${p}_FILES`,
  };
};

export const defaultGlobalSyncConfig: GlobalSyncFlagResult = {
  fromSprouts: true,
  intoSprouts: true,
  isLeadEnabled: false,
  dealEnabled: true,
  syncNewSproutsContactsTo: defaultSyncNewSproutsContactsTo,
  historicInterval: defaultHistoricSyncInterval,
  isHistoricFetchEnabled: false,
  syncFrequency: PollingFrequencyOptions[0],
  isManualSyncEnabled: false,
  isEmailValidationRequire: false,
};

export const customToolTipTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: colors.$tooltipBgColor,
          width: '190px',
          color: colors.$colorWhite,
          fontWeight: 400,
          fontSize: '12px',
          boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.12)',
          borderWidth: '0px 0px 0px 0px',
          borderStyle: 'none',
          borderRadius: '4px',
          position: 'relative',
          top: '10px',
          padding: '0px',
        },
        arrow: {
          color: colors.$tooltipBgColor,
        },
      },
    },
  },
});

export const customWarningToolTipTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: colors.$colorWhite,
          color: colors.$colorBlack,
          fontWeight: 400,
          fontSize: '14px',
          boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.12)',
          border: `1px solid ${colors.$colorDarkPrimary150}`,
          borderRadius: '4px',
          maxHeight: '500px',
        },
      },
    },
  },
});

export const customInfoToolTipTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: colors.$tooltipBgColor,
          width: 320,
          color: colors.$colorWhite,
          fontWeight: 400,
          fontSize: '12px',
          boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.12)',
          borderWidth: '0px 0px 0px 0px',
          borderStyle: 'none',
          borderRadius: '4px',
          position: 'relative',
          padding: '0px',
          marginRight: 80,
        },
        arrow: {
          color: colors.$tooltipBgColor,
          left: '39px !important',
        },
      },
    },
  },
});

interface SyncEntity {
  provider: string;
  provider_entity: string;
  result?: {
    records_created?: number;
    records_updated?: number;
    records_fetched?: number;
    crm_enriched?: number;
  };
}

export const getEntityRecordCount = (
  entity: SyncEntity,
  type: 'created' | 'updated' | 'crm_enriched' | 'fetched',
) => {
  const entityTypeMap = {
    // CRM entities
    [`${entity.provider}_ACCOUNT`]: 'Accounts',
    [`${entity.provider}_CONTACTS`]: 'Contacts',
    [`${entity.provider}_LEAD`]: 'Lead',
    [`${entity.provider}_DEALS`]: 'Opportunity',
    [`${entity.provider}_DEALS_CONTACTS`]: 'DealsContacts',
    // CMP entities
    [`${entity.provider}_SEQUENCE`]: 'Sequence',
    [`${entity.provider}_CALL`]: 'Calls',
    [`${entity.provider}_TASK`]: 'Tasks',
    [`${entity.provider}_MEETING`]: 'Meetings',
    [`${entity.provider}_SENDING`]: 'Sendings',
    [`${entity.provider}_EMAIL`]: 'Emails',
    [`${entity.provider}_SEQUENCE_STEPS`]: 'Sequence Steps',
    [`${entity.provider}_TICKETS`]: 'Tickets',
    [`${entity.provider}_CONVERSATION`]: 'Conversations',
    // Outbound-only CMP entities (Instantly, HeyReach, Mailchimp)
    [`${entity.provider}_CAMPAIGN_CONTACTS`]: 'Contacts',
    // Lemlist entities
    [`${entity.provider}_CAMPAIGNS`]: 'Campaigns',
    [`${entity.provider}_LEADS`]: 'Leads',
    [`${entity.provider}_MESSAGE`]: 'Messages',
    [`${entity.provider}_LIST`]: 'List',
    // Mixpanel entities
    [`${entity.provider}_EVENT`]: 'Event',
    [`${entity.provider}_EVENT_HISTORY`]: 'Event History',
    //G2Crowd entities
    [`${entity.provider}_PRODUCTS`]: 'Products',
    //Trustradius entities
    [`${entity.provider}_INTENT`]: 'Intent',
    [`${entity.provider}_QUOTES`]: 'Quotes',
    //Google Analytics entities
    [`${entity.provider}_REPORT`]: 'Report',
    //Amplitude entities
    [`${entity.provider}_EXPORT`]: 'Export',
    //Teams entities
    [`${entity.provider}_USERS`]: 'Users',
    //Drive entities
    [`${entity.provider}_FILES`]: 'Files',

    [`${entity.provider}_ACCOUNT_CONTACTS`]: 'Account Contact',
  };

  const entityType = entityTypeMap[entity?.provider_entity];

  const recordCount =
    type === 'crm_enriched'
      ? entity?.result?.['crm_enriched']
      : entity?.result?.[`records_${type}`];
  return `${entityType} (${recordCount || 0})`;
};

export const getStatusOption = () => {
  return [
    {
      label: 'All',
      value: 'All',
    },
    {
      label: 'Success',
      value: 'SUCCESS',
    },
    {
      label: 'In Progress',
      value: 'IN_PROGRESS',
    },
    {
      label: 'Failed',
      value: 'FAILED',
    },
  ];
};

export const getSourceOptions = (label: string) => {
  const jobTypes =
    '&job_types=HISTORIC&job_types=ORCHESTRATE&job_types=EXTRACT&job_types=TRANSFORM&job_types=DAG_ORCHESTRATE';

  return [
    {
      label: 'All',
      value: `&job_types=OUTBOUND${jobTypes}`,
    },
    {
      label: 'Sprouts',
      value: '&job_types=OUTBOUND',
    },
    {
      label: label,
      value: jobTypes,
    },
  ];
};

export const getEntityOptions = (
  type: 'CRM' | 'CMP' | 'AUTH',
  label: string,
  providerName: string,
) => {
  // Special handling for outbound-only integrations (Instantly, HeyReach, Mailchimp)
  if (providerName === 'INSTANTLY' || providerName === 'HEYREACH') {
    return [
      {
        label: 'All',
        value: 'All',
      },
      {
        label: 'Lead',
        value: `${providerName}_CAMPAIGN_CONTACTS`,
      },
    ];
  }

  if (providerName === 'MAILCHIMP') {
    return [
      {
        label: 'All',
        value: 'All',
      },
      {
        label: 'Lists',
        value: `${providerName}_LIST`,
      },
    ];
  }

  // Special handling for Intercom (inbound-only: Contacts, Accounts, Tickets, Conversations)
  if (providerName === 'INTERCOM') {
    return [
      {
        label: 'All',
        value: 'All',
      },
      {
        label: 'Contacts',
        value: `${providerName}_CONTACTS`,
      },
      {
        label: 'Accounts',
        value: `${providerName}_ACCOUNT`,
      },
      {
        label: 'Tickets',
        value: `${providerName}_TICKETS`,
      },
      {
        label: 'Conversations',
        value: `${providerName}_CONVERSATION`,
      },
    ];
  }
  // Special handling for Lemlist (inbound-only: Contacts, Accounts, Campaigns, Leads)
  if (providerName === 'LEMLIST') {
    return [
      {
        label: 'All',
        value: 'All',
      },
      {
        label: 'Contacts',
        value: `${providerName}_CONTACTS`,
      },
      {
        label: 'Accounts',
        value: `${providerName}_ACCOUNT`,
      },
      {
        label: 'Leads',
        value: `${providerName}_LEADS`,
      },
    ];
  }

  return type === 'CRM'
    ? [
        {
          label: 'All',
          value: 'All',
        },
        {
          label: 'Contacts',
          value: `${providerName}_CONTACTS`,
        },
        {
          label: 'Accounts',
          value: `${providerName}_ACCOUNT`,
        },
        {
          label: 'Lead',
          value: `${providerName}_LEAD`,
        },
        {
          label: 'Opportunities',
          value: `${providerName}_DEALS`,
        },
      ]
    : [
        {
          label: 'All',
          value: 'All',
        },
        {
          label: 'Contacts',
          value: `${providerName}_CONTACTS`,
        },
        {
          label: 'Accounts',
          value: `${providerName}_ACCOUNT`,
        },
        {
          label: 'Sequences',
          value: `${providerName}_SEQUENCE`,
        },
        {
          label: 'Calls',
          value: `${providerName}_CALL`,
        },
        {
          label: 'Tasks',
          value: `${providerName}_TASK`,
        },
        {
          label: 'Events',
          value: `${providerName}_MEETING`,
        },
        {
          label: 'Mailings',
          value: `${providerName}_SENDING`,
        },
        {
          label: 'Sequence Steps',
          value: `${providerName}_SEQUENCE_STEPS`,
        },
        {
          label: 'Messages',
          value: `${providerName}_MESSAGE`,
        },
      ];
};
export const SalesForceSandboxCustomers = [
  // QA
  'Ajay Test',
  // PROD
  'AKTest13', // TEST ACCOUNT
  'Test Load CRM', // TEST ACCOUNT
  'Yellow.ai', // // CUSTOMER
  'Xurrent', // CUSTOMER
];

/**
 * Sprouts fields available for outbound conditional sync (Sprouts → CRM)
 *
 * SINGLE SOURCE OF TRUTH: Dynamically generated from field definitions in:
 * - contacts.ts (ContactsFieldMappings)
 * - company.ts (CompanyFieldMappings)
 * - lead.ts (LeadFieldMappings)
 *
 * This ensures field mappings and conditional sync stay in sync automatically.
 */
export const OutboundFilterableFields = {
  Account: extractFilterableFields(CompanyFieldMappings),
  Contact: extractFilterableFields(ContactsFieldMappings),
  Lead: extractFilterableFields(LeadFieldMappings),
};

// Operators that require no value input (maps to HubSpot HAS_PROPERTY / NOT_HAS_PROPERTY)
export const ZERO_VALUE_OPERATORS = ['is_not_blank', 'is_blank'];

// Operators that have no HubSpot Search API equivalent and must be hidden for HubSpot providers
export const HUBSPOT_UNSUPPORTED_OPERATORS = ['includes_all_of'];
export const HUBSPOT_ENUMERATION_UNSUPPORTED_OPERATORS = ['is', 'is_not'];

const zeroValueOperators = [
  { value: 'is_not_blank', label: 'is not blank' },
  { value: 'is_blank', label: 'is blank' },
];

// Conditional sync operator definitions - optimized and DRY
const ConditionalSyncOperators: Record<string, Array<{ value: string; label: string }>> = {
  Text: [
    { value: 'is', label: 'is' },
    { value: 'is_not', label: 'is not' },
    { value: 'contains', label: 'contains' },
    { value: 'does_not_contain', label: 'does not contain' },
    ...zeroValueOperators,
  ],
  Reference: [
    { value: 'is', label: 'is' },
    { value: 'is_not', label: 'is not' },
    ...zeroValueOperators,
  ],
  Numeric: [
    { value: 'is', label: 'is' },
    { value: 'is_not', label: 'is not' },
    { value: 'is_greater_than', label: 'is greater than' },
    { value: 'is_less_than', label: 'is less than' },
    { value: 'is_greater_than_or_equal_to', label: 'is greater than or equal to' },
    { value: 'is_less_than_or_equal_to', label: 'is less than or equal to' },
    { value: 'is_between', label: 'is between' },
    ...zeroValueOperators,
  ],
  Date: [
    { value: 'is_on', label: 'is on' },
    { value: 'is_before', label: 'is before' },
    { value: 'is_after', label: 'is after' },
    { value: 'is_on_or_before', label: 'is on or before' },
    { value: 'is_on_or_after', label: 'is on or after' },
    { value: 'is_between', label: 'is between' },
    ...zeroValueOperators,
  ],
  Picklist: [
    { value: 'is', label: 'is' },
    { value: 'is_not', label: 'is not' },
    { value: 'is_any_of', label: 'is any of' },
    { value: 'is_none_of', label: 'is none of' },
    ...zeroValueOperators,
  ],
  Multipicklist: [
    { value: 'includes_all_of', label: 'includes all of' },
    { value: 'includes_any_of', label: 'includes any of' },
    { value: 'includes_none_of', label: 'includes none of' },
    ...zeroValueOperators,
  ],
  Boolean: [{ value: 'is', label: 'is' }, ...zeroValueOperators],
};

// Default operators when field type is unknown
export const defaultConditionalSyncOperators = [
  { value: 'is', label: 'is' },
  { value: 'is_not', label: 'is not' },
  { value: 'is_any_of', label: 'is any of' },
  { value: 'is_none_of', label: 'is none of' },
  { value: 'is_not_blank', label: 'is not blank' },
  { value: 'is_blank', label: 'is blank' },
];

// Logical operator options for connecting multiple conditions (AND/OR)
export const logicalOperatorOptions = [
  { value: 'and', label: 'and' },
  { value: 'or', label: 'or' },
];

// Field type to operator mapping - grouped for clarity and maintainability
// Exported to use as comprehensive field type mapping across the app
export const FieldTypeOperatorGroups: Record<string, string[]> = {
  Text: [
    'string',
    'textarea',
    'entityname',
    'owner',
    'customer',
    'lookup',
    'email',
    'phone',
    'phonenumber',
    'url',
    'id',
    'uniqueidentifiertype',
    'long_text',
    'link',
    'text',
    'lookuptype',
    'entitynametype',
    'virtualtype',
    'stringtype',
    'memotype',
    'customertype',
  ],
  Reference: ['reference', 'ownertype'],
  Numeric: [
    'double',
    'currency',
    'percent',
    'number',
    'integer',
    'int',
    'bigint',
    'long',
    'money',
    'decimal',
    'amount',
    'integertype',
    'decimaltype',
    'biginttype',
    'moneytype',
    'doubletype',
  ],
  Date: ['date', 'datetime', 'zoneddatetime', 'timestamp', 'localdatetime', 'datetimetype'],
  Picklist: [
    'picklist',
    'state',
    'status',
    'custom-preload-single-list',
    'statustype',
    'statetype',
    'picklisttype',
    'enumeration',
  ],
  Multipicklist: ['multipicklist', 'custom-preload-multi-list'],
  Boolean: ['boolean', 'bool', 'booleantype'],
};

// Build the operator mapping dynamically - eliminates repetition
export const conditionalSyncOperatorsByType: Record<
  string,
  Array<{ value: string; label: string }>
> = Object.entries(FieldTypeOperatorGroups).reduce((acc, [operatorGroup, fieldTypes]) => {
  const operators = ConditionalSyncOperators[operatorGroup];
  fieldTypes.forEach((fieldType) => {
    acc[fieldType] = operators;
  });
  return acc;
}, {} as Record<string, Array<{ value: string; label: string }>>);

/**
 * Configuration for activity checkboxes in sync-scenario
 * Maps activity type to its display label and corresponding flag key in globalSyncFlag
 */
export const activityConfig: Record<
  string,
  {
    label: string;
    flagKey: 'callEnabled' | 'meetingEnabled' | 'taskEnabled' | 'emailEnabled';
    hasSubOptions?: boolean;
  }
> = {
  Calls: {
    label: 'Calls (Send as tasks)',
    flagKey: 'callEnabled',
  },
  Meetings: {
    label: 'Meetings (Send as events)',
    flagKey: 'meetingEnabled',
  },
  Tasks: {
    label: 'Tasks (Send as tasks)',
    flagKey: 'taskEnabled',
  },
  Emails: {
    label: 'Emails',
    flagKey: 'emailEnabled',
    hasSubOptions: true,
  },
};

/**
 * SyncScenarioTable Constants
 */
// Entity name mapping for sync scenario table
export const entityNameMap: Record<string, string> = {
  ACCOUNT: 'Account',
  CONTACTS: 'Contact',
  DEALS: 'Deal',
  LEAD: 'Lead',
};

// Maximum number of conditions allowed per entity in sync scenario
export const maxConditionsPerEntity = 10;

// Maps API response entity names to internal key suffixes for sync scenario
// Used to convert API names like "Companies" to keys like "HUBSPOT_ACCOUNT"
export const syncScenarioEntityMapping: Record<string, string> = {
  Companies: 'ACCOUNT',
  Contact: 'CONTACTS',
  Deals: 'DEALS',
  Lead: 'LEAD',
};
